import React from 'react';

interface ModelCategory {
  title: string;
  models: string[];
  icon: string;
  color: string;
}

interface ModelsWeServiceProps {
  title: string;
  subtitle: string;
  modelCategories: ModelCategory[];
}

export const ModelsWeService: React.FC<ModelsWeServiceProps> = ({ title, subtitle, modelCategories }) => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{title}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">{subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {modelCategories.map((category, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 shadow-sm">
              <div className="flex items-center mb-6">
                <div className={`w-12 h-12 ${category.color} rounded-full flex items-center justify-center mr-4`}>
                  <i className={`${category.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{category.title}</h3>
              </div>
              
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {category.models.map((model, modelIndex) => (
                  <div key={modelIndex} className="bg-white rounded-lg p-3 text-center">
                    <span className="text-sm font-medium text-gray-700">{model}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};